<template>
  <section class="intent-credit-choice">
    <el-form-item label="意向金抵扣：" class="width100"><el-radio-group v-model="useCredit" :disabled="busy"><el-radio :label="false">不使用</el-radio><el-radio :label="true">使用意向金</el-radio></el-radio-group></el-form-item>
    <template v-if="useCredit">
      <el-form-item label="选择意向金：" class="width100">
        <p v-if="listLoading">正在查询本客户名下的意向金…</p>
        <p v-else-if="listError" class="credit-error">{{ listError }}</p>
        <el-radio-group v-model="selected" :disabled="busy || loading" class="credit-options">
          <el-radio v-for="item in coupons" :key="item.orderId" :label="item.orderId" class="credit-option">本客户意向金 ¥{{ money(item.amount) }}（单号 {{ item.orderNo }}，{{ item.expiresAt }} 前可用）</el-radio>
          <el-radio label="CODE" class="credit-option">使用其他账号的核销码</el-radio>
        </el-radio-group>
        <p v-if="!listLoading && !listError && !coupons.length">本客户名下暂无可抵扣的意向金，可输入其他账号的核销码</p>
      </el-form-item>
      <el-form-item v-if="selected === 'CODE'" label="意向金核销码：" class="width100"><el-input v-model="code" maxlength="100" :disabled="busy || loading" placeholder="输入意向金核销码" /></el-form-item>
      <el-form-item v-if="selected" label=" " class="width100"><el-button type="text" :loading="loading" :disabled="busy || !effectiveCode" @click="resolve">核对意向金</el-button><p v-if="error" class="credit-error">{{ error }}</p></el-form-item>
      <el-form-item v-if="resolved" label="本次费用：" class="width100"><div>报名总费用 ¥{{ money(resolved.grossAmount) }}</div><div>意向金抵扣 ¥{{ money(resolved.intentAmount) }}</div><div>应付现金 ¥{{ money(resolved.cashDue) }}</div><p>提交后锁定，沿原报名审核核销；不修改原现金凭证。</p></el-form-item>
    </template>
  </section>
</template>
<script>
import api from '@/api/live/intentDeposit'
import { guid } from '@/utils/index'
import { intentMoney } from '@/utils/intent-deposit'
const amountKey = value => {
  const text = String(value == null ? '' : value).trim()
  if (!/^\d+(\.\d{1,2})?$/.test(text)) return text
  const parts = text.split('.'), fraction = (parts[1] || '').replace(/0+$/, '')
  return parts[0].replace(/^0+(?=\d)/, '') + (fraction ? '.' + fraction : '')
}
// BUG-2026-418721：同账号的意向金直接列出勾选；不同账号的凭核销码抵扣
export default {
  props: { customerId: [String, Number], targetLevelId: [String, Number], grossAmount: [String, Number], busy: Boolean },
  data() { return { useCredit: false, selected: '', code: '', coupons: [], listLoading: false, listError: '', listSequence: 0, loading: false, error: '', resolved: null, resolvedFor: '', requestId: '', sequence: 0 } },
  computed: {
    effectiveCode() {
      if (this.selected === 'CODE') return this.code.trim()
      const item = this.coupons.find(c => c.orderId === this.selected)
      return item ? item.couponCode : ''
    },
    listKey() { return [String(this.customerId || ''), String(this.targetLevelId || '')].join('|') },
    identity() { return JSON.stringify([String(this.customerId || ''), String(this.targetLevelId || ''), amountKey(this.grossAmount), this.effectiveCode]) }
  },
  watch: {
    identity() { this.invalidate() },
    useCredit(value) { this.invalidate(); if (value) this.loadCoupons() },
    listKey() { if (this.useCredit) this.loadCoupons() },
    selected(value) { if (value && value !== 'CODE' && String(this.grossAmount || '').trim()) this.$nextTick(this.resolve) }
  },
  beforeDestroy() { ++this.sequence; ++this.listSequence },
  methods: {
    money: intentMoney,
    invalidate() { ++this.sequence; this.resolved = null; this.resolvedFor = ''; this.requestId = ''; this.error = ''; this.loading = false },
    async loadCoupons() {
      const sequence = ++this.listSequence
      this.coupons = []; this.listError = ''; if (this.selected !== 'CODE') this.selected = ''
      if (!this.customerId || !this.targetLevelId) { this.listError = '请先选择客户和要升级的身份'; return }
      this.listLoading = true
      try {
        const response = await api.joinCoupons({ targetCustomerId: String(this.customerId), targetLevelId: String(this.targetLevelId) })
        if (sequence !== this.listSequence) return
        this.coupons = response.data || []
        if (!this.selected) this.selected = this.coupons.length ? this.coupons[0].orderId : 'CODE'
      } catch (error) { if (sequence === this.listSequence) { this.listError = error.message || '意向金查询失败'; this.selected = 'CODE' } }
      finally { if (sequence === this.listSequence) this.listLoading = false }
    },
    async resolve() {
      if (!this.useCredit || this.busy || this.loading || !this.effectiveCode) return
      this.invalidate()
      const sequence = this.sequence, identity = this.identity
      this.loading = true
      try {
        const response = await api.resolveCode({ targetCustomerId: String(this.customerId), targetLevelId: this.targetLevelId, grossAmount: String(this.grossAmount), couponCode: this.effectiveCode })
        if (sequence !== this.sequence || identity !== this.identity || !this.useCredit) return
        if (!response.data || response.data.canApply !== true) throw new Error('当前意向金不可用于本次升级')
        this.resolved = response.data; this.resolvedFor = identity; this.requestId = guid()
      } catch (error) { if (sequence === this.sequence) this.error = error.message || '意向金核对失败' }
      finally { if (sequence === this.sequence) this.loading = false }
    },
    getSubmission(expected) {
      if (!this.useCredit) return {}
      if (expected && [String(expected.customerId), String(expected.targetLevelId), amountKey(expected.grossAmount)].join('|') !== [String(this.customerId), String(this.targetLevelId), amountKey(this.grossAmount)].join('|')) throw new Error('本次客户、身份或费用已变化，请重新核对意向金')
      if (this.loading || !this.resolved || this.resolvedFor !== this.identity || !this.requestId) throw new Error('请先选择意向金并核对本次身份和费用')
      return { couponCode: this.effectiveCode, intentRequestId: this.requestId }
    }
  }
}
</script>
<style scoped>.credit-error { color: #f56c6c; } p { margin: 5px 0; font-size: 12px; } .credit-options { display: flex; flex-direction: column; align-items: flex-start; } .credit-option { margin: 4px 0; line-height: 20px; }</style>
